module.exports = __webpack_public_path__ + "media/assets/mobileHeaderBtnBlue-0f4d58dce4be5ef81e0d4c756b3c685b.png";